export default __webpack_public_path__ + "static/media/apply_04_active.6ec38560.png";